import React, { useState } from "react";
import { IconSearch, IconX } from "@tabler/icons-react";
import { useCRM } from "../CRMContext";

const SearchBar = () => {
  const { state, setSearchQuery, performSearch } = useCRM();
  const [localQuery, setLocalQuery] = useState(state.searchQuery);

  const handleSearch = () => {
    const trimmed = localQuery.trim();
    setSearchQuery(trimmed);
    performSearch(trimmed);
  };

  const handleClear = () => {
    setLocalQuery("");
    setSearchQuery("");
    performSearch("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="crm-search">
      <IconSearch size={16} className="crm-search__icon" />
      <input
        type="text"
        className="crm-search__input"
        placeholder="Buscar contatos..."
        value={localQuery}
        onChange={(e) => setLocalQuery(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      {localQuery && (
        <button className="crm-search__clear" onClick={handleClear}>
          <IconX size={14} />
        </button>
      )}
      <button
        className="crm-search__submit"
        onClick={handleSearch}
        title="Buscar"
      >
        <IconSearch size={16} />
      </button>
    </div>
  );
};

export default SearchBar;
